export default __webpack_public_path__ + "static/media/gives.2ce8b062.svg";